import styled from 'styled-components';
import { secondaryText } from 'styles/theme';

const Container = styled.span`
    color: ${secondaryText};
`;

export function NoValue() {
    return <Container>--</Container>;
}
